export const SET_ENTIDADE_ACTION = 'setEntidade';
export const FETCH_ENTIDADES_ACTION = 'fetchEntidades';
export const INITIALIZE_FROM_COOKIES_ACTION = 'initFromCookies';
export const INITIALIZE_FROM_VALUE = 'initFromValue';
